/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import { $ } from './lib'
import numeral from 'numeral'
import { Notyf } from 'notyf';
import * as TEMPLATE from './templates';

/*------------------------------------------------------------------
Endpoint constants
------------------------------------------------------------------*/

const WISHLIST = 'api-wishlist/';
const WISHLIST_GET_ALL = 'api-wishlist/get_all';
const WISHLIST_EDIT_COMMENT = 'api-wishlist/edit_comments';
const WISHLIST_MOVE_TO_CART = 'api-wishlist/move_cart';

const CART_ADD = 'shop-api/cart/add';
const CART_REMOVE = 'shop-api/cart/remove';
const CART_GET = 'shop-api/cart/get';


let notyf = new Notyf({
    duration: 4000,
    dismissible: true,
    icon: false
});


/**
 * 
 * Remove an item from the sidecart 
 * @param {number} id 
 * 
 */
export const removeItemFromCart = (id) => {
    let item = $(`.cart__list__item[data-id="${id}"]`);
    item.classList.add('cart__list__item--removed');
    quickRemove(id);
};



/**
 * 
 * Move an item from the wishlist to the cart
 * @param {number} id 
 * 
 */
export const moveToCart = (id) => {
    return fetch(`${WISHLIST_MOVE_TO_CART}/${id}`, {
        method: 'POST'
    }).then((response) => response.json())
};

/**
 * 
 * Render the wishlist items
 * 
 * @param {collection} wishlist 
 * @param {string} html 
 */
export const renderWishlist = (wishlist, html = '') => {

    // If the user has no items in their wishlist, show a message
    if (wishlist.length === 0) html = TEMPLATE.wishlistEmpty();

    // Overwrite the wishlist items with our new html
    $('.js-wishlist-items').innerHTML = html;

};


export const updateWishlistPage = (data) => {
    fetch(WISHLIST_GET_ALL, {
        method: 'POST'
    })
        .then((response) => response.json())
        .then((data) => {

            // Store our wislist globally
            window.wishlist = data.data.items;

            // Rerender the wishlist items (but now with pre rendered html)
            renderWishlist(data.data.items, data.data.html);
        })
        .catch((data) => {
            notyf.error({ message: data.message, icon: false });
        });
};



export const editWishlistComment = (id, comment) => {
    fetch(`${WISHLIST_EDIT_COMMENT}/${id}/?comments=${comment}`, {
        method: 'POST'
    })
        .then((response) => response.json())
        .then((data) => {
            notyf.success({ message: data.message, icon: false });
        }).catch((data) => {
            notyf.error({ message: data.message, icon: false });
        });
};



/**
 * 
 * Remove an ditem from the sidecart 
 * @param {number} id 
 * 
 */
export const toggleItemFromWishlist = (id, type) => {
    return fetch(`${WISHLIST}${type}/${id}`, {
        method: 'POST'
    }).then((response) => response.json())
};


/**
 * 
 * Add an item to the cart
 * @param {event} e 
 * 
 */
export const quickAdd = (id, quantity = 1, button) => {
    return fetch(`${CART_ADD}?product_id=${id}`, {
        method: 'POST',
        body: JSON.stringify({ quantity: quantity, ID: id }),
    }).then((response) => response.json())
};

/**
 * 
 * Add an item to the cart
 * @param {event} e 
 * 
 */
export const addToCart = (url, quantity = 1, button) => {
    return fetch(`${url}`, {
        method: 'POST',
        body: JSON.stringify({ quantity: quantity }),
    }).then((response) => response.json())
};

/**
 * 
 * Remove an item from the cart
 * @param {event} e 
 * 
 */
export const quickRemove = (id, quantity = 1, button) => {
    return fetch(`${CART_REMOVE}?product_id=${id}`, {
        method: 'POST',
        body: JSON.stringify({ quantity: quantity, ID: id }),
    }).then((response) => response.json())
};

/**
 * 
 * Remove an item from the cart
 * @param {event} e 
 * 
 */
export const removeAllFromCart = (url) => {
    return fetch(url, {
        method: 'POST',
    }).then((response) => response.json())
};


/**
 * 
 * Add one to the quantity of an item
 * @param {event} e 
 * 
 */
export const addQuantity = (e) => {
    e.preventDefault();
    let $quantity = e.target.parentNode.parentNode.querySelector('input');
    let quantity = parseInt($quantity.value) + 1;
    $quantity.value = quantity;
};


/**
 * 
 * Subtract one to the quantity of an item
 * @param {event} e 
 * 
 */
export const subtractQuantity = (e) => {
    e.preventDefault();
    let $quantity = e.target.parentNode.parentNode.querySelector('input');
    let quantity = parseInt($quantity.value) - 1;
    if (quantity < 1) quantity = 1;
    $quantity.value = quantity;
};



/**
 * 
 * Add an item to the cart
 * @param {event} e 
 * 
 */
export const fetchWishlist = () => {
    return fetch(WISHLIST_GET_ALL)
        .then((response) => response.json())
};


/**
 * 
 * Fetch a users cart
 * @param {event} e 
 * 
 */
export const fetchCart = () => {
    return fetch(CART_GET)
        .then((response) => response.json())
};


/**
 * 
 * Render the sidecart
 * 
 * @param {*} cart 
 * @param {*} html 
 */
export const updateHeaderIcon = (cart, show_pulse = true) => {

    // Declare our header icon
    let $headerIcon = $('.js-cart-count-icon');

    // Lopp through our cart items and render template fragments
    if (cart.items && cart.items.length) {
        let count = 0;
        cart.items.forEach((item) => count = count + item.quantity);
        $headerIcon.innerHTML = count;
        if (show_pulse) $headerIcon.classList.add('pulse');

    }

    // If we have an empty cart
    else {
        $headerIcon.innerHTML = ``;
    }

    // Remove the pulse animation class after the animation ends
    setTimeout(() => $headerIcon.classList.remove('pulse'), 3000);

    // Declare our header icon
    let $headerIconMobile = $('.js-cart-count-icon-mobile');


    // Lopp through our cart items and render template fragments
    if (cart.items && cart.items.length) {
        let count = 0;
        cart.items.forEach((item) => count = count + item.quantity);
        $headerIconMobile.innerHTML = count;
    }

    // If we have an empty cart
    else {
        $headerIconMobile.innerHTML = ``;
    }

};


/**
 * 
 * Render the sidecart
 * 
 * @param {*} cart 
 * @param {*} html 
 */
export const updateWishlistIcon = (wishlist, show_pulse = true) => {

    // Declare our header icon
    let $wishlistIcon = $('.js-wishlist-count-icon');

    // Lopp through our cart items and render template fragments
    if (wishlist && wishlist.length) {
        $wishlistIcon.innerHTML = wishlist.length;
        if (show_pulse) $wishlistIcon.classList.add('pulse');
    }

    // If we have an empty wishlist
    else {
        $wishlistIcon.innerHTML = ``;
    }

    // Remove the pulse animation class after the animation ends
    setTimeout(() => $wishlistIcon.classList.remove('pulse'), 3000);


    // Declare our header icon
    let $wishlistIconMobileMenu = $('.js-wishlist-count-icon-mobile');
    if (wishlist && wishlist.length) {
        $wishlistIconMobileMenu.innerHTML = wishlist.length;
    }
    // If we have an empty wishlist
    else {
        $wishlistIconMobileMenu.innerHTML = ``;
    }

};



/**
 * 
 * Render the sidecart
 * 
 * @param {*} cart 
 * @param {*} html 
 */
export const updateSidecart = (cart, html = '') => {


    let $sidecart = $('.side-cart__tray__body');

    // Lopp through our cart items and render template fragments
    if (cart.items && cart.items.length) {
        cart.items.forEach((item) => {
            html += TEMPLATE.sideCartItem(item);
        });

        // Update the side cart total
        $('.side-cart__tray__footer span').innerHTML = `${numeral(parseFloat(cart.subtotal).toFixed(2)).format('$0,0.00')}`

        $('.side-cart__tray__footer').style.display = 'block';
    }
    // If we have an empty cart
    else {
        html += TEMPLATE.sideCartEmpty();

        // Update the side cart total
        $('.side-cart__tray__footer span').innerHTML = `$0.00`

        $('.side-cart__tray__footer').style.display = 'none';
    }

    $sidecart.innerHTML = html;

};

/**
 * 
 * Render the sidecart
 * 
 * @param {*} cart 
 * @param {*} html 
 */
export const updateCheckout = (cart, html = '') => {

    let $checkout = $('.js-checkout');

    if (!$checkout) return;

    // Lopp through our cart items and render template fragments
    if (cart.items && cart.items.length) {
        cart.items.forEach((item) => {
            html += TEMPLATE.checkoutItem(item);
        });

        html += TEMPLATE.checkoutTotals(cart);
    }
    // If we have an empty cart
    else {
        html += TEMPLATE.checkoutEmpty();
    }

    $checkout.innerHTML = html;

};


/**
 * 
 * Render the sidecart
 * 
 * @param {*} cart 
 * @param {*} html 
 */
export const updateCart = (cart, html = '') => {
    let $cart = $('.js-cart');

    // Lopp through our cart items and render template fragments
    if (cart.items && cart.items.length) {
        html += TEMPLATE.cartListHeader();
        cart.items.forEach((item) => {
            html += TEMPLATE.cartListItem(item);
        });
    }
    // If we have an empty cart
    else {

    }

    $cart.innerHTML = html;

};


/**
 * 
 * Register the analytics for removing an item from the cart
 * 
 * @param {object} cart 
 * @param {number} id 
 * @param {number} quantity 
 */
export const removeItemAnalytics = (cart, id, quantity = 1) => {

    let product = null;

    if (cart.length) {

        product = cart.find(product => {
            if (product.product_id === parseInt(id)) return product;
        });

        if (product) {

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': 'remove_from_cart',
                'ecommerce': {
                    'currencyCode': 'AUD',
                    'value': (quantity * product.unit_price),
                    'add': {
                        'products': [{
                            'name': product.title,
                            'id': product.sku,
                            'price': product.unit_price,
                            'category': product.range,
                            'variant': product.product_id,
                            'quantity': quantity
                        }]
                    }
                }
            });
        }
    }

};

/**
 * 
 * Register the analytics for removing an item from the cart
 * 
 * @param {object} cart 
 * @param {number} id 
 * @param {number} quantity 
 */
export const addItemAnalytics = (cart, id, quantity = 1) => {

    let product = null;

    if (cart.length) {

        product = cart.find(product => {
            if (product.product_id === parseInt(id)) return product;
        });

        if (product) {

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': 'add_to_cart',
                'ecommerce': {
                    'currencyCode': 'AUD',
                    'value': (quantity * product.unit_price),
                    'add': {
                        'products': [{
                            'name': product.title,
                            'id': product.sku,
                            'price': product.unit_price,
                            'category': product.range,
                            'variant': product.product_id,
                            'quantity': quantity
                        }]
                    }
                }
            });

        }
    }

};